export default __webpack_public_path__ + "static/media/money-back@2x.fa3c0473.png";